import { Controller } from "@hotwired/stimulus"

// Mirrors a form field's value into a URL query param so the page stays
// shareable. Each triggering field supplies its param name via an action param:
//   data-action="change->url-param#update"
//   data-url-param-name-param="office_policy"
export default class extends Controller {
  update(event) {
    const name = event.params.name
    if (!name) return

    const value = event.target.value
    const url = new URL(window.location)
    if (value) {
      url.searchParams.set(name, value)
    } else {
      url.searchParams.delete(name)
    }
    window.history.replaceState({}, "", url)
  }

  // Mirror a checkbox group's checked values into repeated `name[]` params
  // (the shape Rails' params.permit(attr: []) parses back on reload).
  updateArray(event) {
    const name = event.params.name
    if (!name) return

    const key = `${name}[]`
    const url = new URL(window.location)
    url.searchParams.delete(key)
    event.target.form
      .querySelectorAll(`input[type="checkbox"][name="${event.target.name}"]:checked`)
      .forEach(box => url.searchParams.append(key, box.value))
    window.history.replaceState({}, "", url)
  }
}
